// extracted by mini-css-extract-plugin
export default {"register":"Register_register__JgjT6","title":"Register_title__P5kbr"};